export default {
    name: 'Name',
    identifier: 'Kürzel',
    identifierHelpTextNew: 'Das Kürzel muss eindeutig sein. Es darf sich in keinem anderen Formular wiederholen.',
    identifierHelpTextExisting: 'Das Kürzel sollte nur in Rücksprache mit den Entwicklern von //farbcode geändert werden.',
    fundingProgram: 'Förderprogramm',
    type: 'Typ',
    types: {
        request: 'Antrag',
        proof: 'Verwendungsnachweis',
        goal_agreement: 'Zielvereinbarung',
        transfer_agreement: 'Weiterleitungsvertrag',
        goal_achievement: 'Auswertung',
        audit_note: 'Prüfvermerk',
        final_approval: 'Endbewilligung'
    },
    sub_heading: 'Untertitel',
    sub_heading_description: 'Der Untertitel wird beim Beantragen des Formulars angezeigt.',
    sort: 'Sortierung',

    cannotCreateEvent: 'Dieses Formular kann keine Maßnahme starten. Bitte fügen Sie es einer bestehenden Maßnahme hinzu.',
    noMultipleOccurrencesInEvent: 'Dieses Formular kann nur einmal in einer Maßnahme vorkommen.',
    cannotCreateProcess: 'Dieses Formular kann keinen neuen Vorgang starten. Bitte fügen Sie es einem bestehenden Vorgang hinzu.',
    noMultipleOccurrenceInProcess: 'Dieses Formular kann nur einmal in einem Vorgang vorkommen.',
    cannotAddForm: 'Dieses Formular kann nicht verwendet werden.',

    is_active: 'Aktiv',
    signature_required: 'Digitale Unterschrift erlauben',
    signature_required_help_text: 'Wenn aktiviert, kann dieses Formular digital unterschrieben werden. Ob die digitale Unterschrift verpflichtend oder optional ist, wird durch die Verbandseinstellungen des Antragstellers festgelegt.',
    management_signature_required: 'Digitale Unterschrift der aej erforderlich',
    management_signature_required_help_text: 'Wenn aktiviert, muss die aej das Formular digital unterschreiben.',
    can_be_created_inside_application_area: 'Kann im Antragsbereich erstellt werden',
    can_be_created_inside_application_area_help_text: 'Wenn aktiviert, kann das Formular im Antragsbereich erstellt werden. Wenn nicht aktiviert, kann es nur vom Sachbearbeiter im Verwaltungsbereich erstellt werden.',
    can_be_edited_inside_application_area: 'Kann im Antragsbereich bearbeitet werden',
    can_be_edited_inside_application_area_help_text: 'Wenn aktiviert, kann das Formular im Antragsbereich bearbeitet werden - sofern die Bearbeitung im aktuellen Status zugelassen ist.',
    can_create_new_event: 'Kann neue Maßnahme starten',
    can_create_new_event_help_text: 'Wenn nicht aktiviert, darf das Formular nur in einer bereits bestehenden Maßnahme angelegt werden.',
    multiple_occurrence_in_event: 'Mehrfach vorkommend in Maßnahme',
    multiple_occurrence_in_event_help_text: 'Wenn aktiviert, darf das Formular mehrfach in einer Maßnahme vorkommen.',
    can_create_new_process: 'Kann neuen Vorgang starten',
    can_create_new_process_help_text: 'Wenn nicht aktiviert, darf das Formular nur in einem bereits bestehenden Vorgang angelegt werden.',
    multiple_occurrence_in_process: 'Mehrfach vorkommend im Vorgang',
    multiple_occurrence_in_process_help_text: 'Wenn aktiviert, darf das Formular mehrfach in einem Vorgang vorkommen.',
    update_event_persons: 'Kann Personen bearbeiten',
    update_event_persons_help_text: 'Wenn aktiviert, können die Personen im Formular bearbeitet werden.',
    excel_exportable: 'Excel-Export erlaubt',
    excel_exportable_help_text: 'Wenn aktiviert, kann das Formular als Excel-Datei exportiert werden.',
    excel_importable: 'Excel-Import erlaubt',
    excel_importable_help_text: 'Wenn aktiviert, kann das Formular als Excel-Datei importiert werden.',

    eventFields: 'Maßnahmenfelder',
    allEventFields: {
        name: 'Name',
        date: 'Datum',
        location: 'Ort',
        locationTitle: 'Name des Ortes',
        locationAddress: 'Adresse des Ortes',
        locationIndependent: 'Ortsungebundene Maßnahme',
    },
    eventPersonFields: 'Versteckte Personenfelder',
    allEventPersonFields: {
        gender: 'Geschlecht',
        genders: {
            male: 'Geschlecht - männlich',
            female: 'Geschlecht - weiblich',
            diverse: 'Geschlecht - divers',
            other: 'Geschlecht - Keine Angabe'
        },
        firstname: 'Vorname',
        lastname: 'Nachname',
        birthday: 'Geburtsdatum',
        'function': 'Funktion',
        functions: {
            participant: 'Funktion - Teilnehmende*r',
            staff: 'Funktion - Mitarbeitende*r',
            leader: 'Funktion - Leitung'
        },
        address: 'Adresse',
        participation_begin: 'Teilnahmebeginn',
        participation_end: 'Teilnahmeende',
        participation_duration: 'Teilnahmedauer',
    },

    formFieldConfig: 'Formularfelderkonfiguration',

    uploadBoxConfig: 'Uploadbereichkonfiguration',
    visibilitySectionHelpText: 'Die Sichtbarkeit der Boxen hängt an den bei dem zugehörigen Förderprogramm hinterlegten Rechten',
    visibilitySection: {
        personsData: 'Personendaten',
        eventData: 'Maßnahmendaten',
        ownFiles: 'Nur für eigene Organisation sichtbar',
        alwaysVisible: 'Immer sichtbar'
    },
    visibleIfHelpText: 'Hier wird die Sichtbarkeit der Boxen beim Beantragen des Formulars gesteuert. Die Sichtbarkeit ' +
        'der Boxen kann sich hier während dem Ausfüllen des Formulars ändern. Wird verwendet bei TN-Listen oder Programmnachweisen.',

    editEventPersonCustomField: 'Formularspezifisches Personenfeld {name} bearbeiten',
    saveEventPersonCustomField: 'Formularspezifisches Personenfeld speichern',
    deleteEventPersonCustomField: 'Formularspezifisches Personenfeld löschen',
    deleteEventPersonCustomFieldText: 'Möchten Sie dieses formularspezifische Personenfeld wirklich löschen?',

    saveSuccess: 'Formular wurde erfolgreich gespeichert.',
    deleteForm: 'Formular löschen',
    deleteFormText: 'Möchten Sie dieses Formular wirklich löschen?',
    deleteFormSuccess: 'Formular wurde erfolgreich gelöscht.',
    deleteFormError: 'Das Formular konnte nicht gelöscht werden.',

    table: {
        title: 'Formulare',
        id: 'ID',
        name: 'Name',
        identifier: 'Kürzel',
        type: 'Typ',
        fundingProgram: 'Förderprogramm',
        is_active: 'Aktiv',
        sort: 'Sortierung',

        qf_activeOnly: 'Nur aktive Formulare'
    },

    menu: {
        formBaseData: 'Daten',
        configuration: 'Konfiguration',
        formClass: 'Formularklasse',
        exportTemplate: 'PDF Vorlage',
        eventPersonCustomFields: 'Formularspezifische Personenfelder'
    }
}